import type { QueryClient } from '@tanstack/react-query'

import { RequestActivityQueryKeys } from './queryKeys'

/** Prefix-match so every mounted ForRequest feed refetches after an audit event is written. */
export const invalidateRequestActivityQueries = (queryClient: QueryClient): void => {
  queryClient.invalidateQueries({ queryKey: RequestActivityQueryKeys.All() })
}
